class CookieBubble extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.attachListeners();
    }

    checkCookies() {
        if (localStorage.getItem('cookiesAccepted')) {
            this.style.display = 'none';
        } else {
            this.style.display = 'block';
        }
    }

    attachListeners() {
        const closeButtons = [this.querySelector(".cookieBubbleCloseButton"), this.querySelector("#cookieBubbleAcceptAll")].filter(Boolean);

        closeButtons.forEach((button) => {
            button.addEventListener("click", () => {
                this.handleClose();
            });
        });

        window.addEventListener('pageshow', () => this.checkCookies());
    }

    handleClose() {
        localStorage.setItem('cookiesAccepted', 'true');
        this.style.display = 'none';
    }
}

customElements.define('cookie-bubble', CookieBubble);
